export default __webpack_public_path__ + "resources/icons/d222-8a50.png";